<template>
  <div id="app">
    <top-nav-bar />
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar'
export default {
  components: { TopNavBar }
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Exo:300,500,700')

$body-background-color: #243a44
$input-background-color: #CBD4C2
$card-background-color: $input-background-color
$primary: #2b929d
$info: #3574A5
$success: #2CA58D
$danger: #862f2f
$text: #d0cfbd
$link-hover: lighten($primary, 10%)
$family-sans-serif: 'Exo', BlinkMacSystemFont, -apple-system, "Segoe UI", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif

// Navbar styling
$navbar-background-color: $body-background-color
$navbar-item-color: darken($text, 20%)
$navbar-item-hover-background-color: lighten($navbar-background-color, 10%)
$navbar-item-hover-color: lighten($text, 20%)
$navbar-dropdown-background-color: red

// Forms styling
$label-color: $text

.fade-enter-active, .fade-leave-leave-to
  transition: all 0.1s linear

.fade-enter, .fade-leave-to
  opacity: 0

@import './../node_modules/bulma/bulma.sass'
</style>
